export default __webpack_public_path__ + "static/media/language.6e32813e.png";